module.exports = __webpack_public_path__ + "img/compra.364b18c0.webp";